import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {deleteSsoSettings} from 'src/openapi/admin/apis/AccountSingleSignOnApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    accountId: number,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useDeleteSsoSettings = ({accountId, onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();
    const eventAction = useCallback(() => apiDispatch(
        deleteSsoSettings({accountId}),
    ), [accountId, apiDispatch]);
    return useCommonEventHook({eventAction, onSuccess, onFail});
};
